module.exports = __webpack_public_path__ + "media/images/donate-hero-mobile-5b8b50ddbe75e2f40c97a32fd42da5a5.jpg";